const CptName = 'ComLine'
function formatData (node) {
  console.dir(node);
  return {
    data: {
      children: []
    },
    cpt: CptName
  }
}

export default {
  install (Vue) {
    Vue.component(CptName, require('./index.vue').default)
    window.hb__format['line'] = formatData
  }
}